'use client';

import { css } from '@onbeam/business-styled-system/css';
import { flex, vstack } from '@onbeam/business-styled-system/patterns';
import { Button } from '@onbeam/business-ui';
import { FormStepsProps } from './FormSteps.types';
import { useBreakpoint } from '@onbeam/utils';
import { token } from '@onbeam/business-styled-system/tokens';
import { Tooltip } from '@/components/shared/Tooltip';

// TODO: Add tooltips per step
export const FormSteps = ({
  steps,
  activeStep,
  onContinue,
  onNavigate,
  onPrevious,
}: FormStepsProps) => {
  const isMobile = useBreakpoint({ max: token('breakpoints.md') });

  const isLastStep = activeStep === steps.length - 1;

  return (
    <div
      className={vstack({
        position: 'fixed',
        insetX: '0',
        bottom: '0',
        w: 'full',
        zIndex: '10',
        bg: 'mono.primaryFg',
      })}
    >
      <div
        className={flex({
          w: 'full',
          gap: '1.5',
        })}
      >
        {steps.map((step, index) => (
          <Tooltip key={index} label={step.title}>
            <button
              type="button"
              data-active-step={index <= activeStep}
              onClick={() => onNavigate?.(index)}
              className={flex({
                flexGrow: 1,
                h: '[0.5rem]',
                transition: 'colors',
                transitionProperty: 'background-color, opacity',
                cursor: 'pointer',

                '&[data-active-step="true"]': {
                  bg: 'mono.primaryBg',
                  _supportsHover: {
                    _hover: {
                      bg: 'mono.secondary',
                    },
                  },
                  _focusVisible: {
                    bg: 'mono.secondary',
                  },
                },
                '&[data-active-step="false"]': {
                  bg: 'mono.quartenery',
                  _supportsHover: {
                    _hover: {
                      bg: 'mono.quinary',
                    },
                  },
                  _focusVisible: {
                    bg: 'mono.quinary',
                  },
                },
              })}
            />
          </Tooltip>
        ))}
      </div>
      <div
        className={flex({
          px: '6',
          py: '4',
          justify: 'space-between',
          gap: '4',

          md: {
            px: '10',
          },
        })}
      >
        {(isMobile || activeStep !== 0) && (
          <Button
            variant="secondary"
            size={isMobile ? 'fullWidth' : 'lg'}
            disabled={activeStep === 0}
            onClick={onPrevious}
          >
            Back
          </Button>
        )}
        <Button
          className={css({ ml: 'auto' })}
          size={isMobile ? 'fullWidth' : 'lg'}
          onClick={onContinue}
        >
          {isLastStep ? 'Review' : 'Next'}
        </Button>
      </div>
    </div>
  );
};
